import React, { useEffect, useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import { Link } from 'react-router-dom';

function CreatePost() {
    const {currentUser } = useSelector((state) => ({
        currentUser: state.profile.currentUser,
        }));
    return (
        <div className="card border-0 rounded-xl shadow-xs mb-3">
            <div className="card-body d-flex px-4">
                <div className="d-flex align-items-center">
                    <div className="mmwh-35 bg-light text-primary d-flex align-items-center justify-content-center rounded-pill me-2">
                        <svg className="icon icon-1x"><use href="#icon_borderline"></use></svg>
                    </div>
                    <span className="fs-12 fw-bold text-muted text-nowrap">Create Post</span>
                </div>
            </div>
            <div className="card-body py-0 px-4">
                <figure className="position-absolute ms-2 mt-2 top-5">
                    <img src={currentUser?.profileImageUrl} className=""alt="icon" className="shadow-sm rounded-circle mmwh-32"/>
                </figure>
                <textarea className="form-control rounded-xl fw-medium fs-13 ps-5 pt-3" placeholder="What's on your mind?" spellCheck="false" rows="4"></textarea>
            </div>
            <div className="card-body d-flex align-items-end px-4">
                <ul className="list-inline mb-0">
                    <li className="list-inline-item me-4">
                        <Link to="#" className="d-flex align-items-center text-decoration-none">
                            <svg className="icon fs-20 text-green me-2"><use href="#icon_image"></use></svg>
                            <span className="fs-12 fw-bold text-grey">Photo/Video</span>
                        </Link>
                    </li>
                </ul>
                <div className="ms-auto align-self-end dropdown">
                    <button type="button" data-bs-toggle="dropdown" className="btn mmwh-35 bg-light text-grey p-0 rounded-pill">
                        <svg className="icon icon-3x"><use href="#icon_hdots"></use></svg>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end border-0 rounded-xl shadow-xs">
                        <li className="my-1">
                            <button className="dropdown-item d-flex align-items-center" type="button">
                                <div className="text-muted lh-sm">
                                    <svg className="icon fs-26"><use href="#icon_bookmark"></use></svg>
                                </div>
                                <div className="fw-semibold ms-2">
                                    <div className="fs-12">Save Link</div>
                                    <div className="text-muted fs-10">Add this to your saved items</div>
                                </div>
                            </button>
                        </li>
                        <li className="my-1">
                            <button className="dropdown-item d-flex align-items-center" type="button">
                                <div className="text-muted lh-sm">
                                    <svg className="icon fs-26"><use href="#icon_alert"></use></svg>
                                </div>
                                <div className="fw-semibold ms-2">
                                    <div className="fs-12">Hide Post</div>
                                    <div className="text-muted fs-10">Save to your saved items</div>
                                </div>
                            </button>
                        </li>
                        <li className="my-1">
                            <button className="dropdown-item d-flex align-items-center" type="button">
                                <div className="text-muted lh-sm">
                                    <svg className="icon fs-26"><use href="#icon_reportalert"></use></svg>
                                </div>
                                <div className="fw-semibold ms-2">
                                    <div className="fs-12">Hide all from group</div>
                                    <div className="text-muted fs-10">Save to your saved items</div>
                                </div>
                            </button>
                        </li>
                        <li className="my-1">
                            <button className="dropdown-item d-flex align-items-center" type="button">
                                <div className="text-muted lh-sm">
                                    <svg className="icon fs-25"><use href="#icon_block"></use></svg>
                                </div>
                                <div className="fw-semibold ms-2">
                                    <div className="fs-12">Unfollow Group</div>
                                    <div className="text-muted fs-10">Save to your saved items</div>
                                </div>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
export default CreatePost;